import {ReactNode} from 'react';

type ErrorProps = {
  message: Nullable<string | ReactNode[]>
}

const Error = ({message}: ErrorProps) => {
  if (!message) return null;

  return (
    <div className="message-box error">
      {message}
    </div>);
};

export default Error;
